<template>
    <div>
        <div class="header" ref='header'>
          <div :style="{'padding-top': this.$route.params.NavBarHeight+'px', 'height': ((228 + this.$route.params.NavBarHeight) / 375) * 100% + 'px'}">
            <div class="header-line-1">
                <div>
                    <div id='player-name'>{{ chineseName }}</div>
                    <div class='sub-title-1'>{{ enName }}</div>
                    <div class='sub-title-2'>
                        {{ player.birthday }}&nbsp;/&nbsp;{{ player.nationality }}
                    </div>
                    <div class='sub-title-2'>
                      <span>
                          {{ $t("playerIndex.height") }}：{{ player.height }}
                      </span>
                      <span>
                          {{ $t("playerIndex.bodyWeight") }}：{{ player.weight }}
                      </span>
                    </div>
                </div>
                <playerAvatar id='avatar' :playerId='playerId'/>
            </div>
            <div class="header-line-2">
              <div>
                  <div class='sub-title-3'>
                    {{ player.position }}&nbsp;/&nbsp;{{ player.jerseyNumber + $t('teamPlayerList.number') }}
                  </div>
                  <div class='sub-title-1'>
                    {{ $t("playerIndex.playerPosition") }}&nbsp;/&nbsp;{{ $t("playerIndex.jerseyNumber") }}
                  </div>
              </div>
              <div>
                <div class='sub-title-3'>{{ player.team }}</div>
                <div class='sub-title-1'>{{ $t("playerInfo.playingTeam") }}</div>
              </div>
            </div>
          </div>
        </div>
        <nav-list :routers="routers">
          <keep-alive>
            <router-view ref='routerView'/>
          </keep-alive>
        </nav-list>
    </div>
</template>

<script>
import NavList from '@/components/NavList'
import playerAvatar from '@/components/PlayerAvatar'
import { scrollHeaderMinxin } from '@/views'

export default {
  name: 'player',
  props: {
    playerId: {
      type: String,
      required: true,
      default: () => '0'
    }
  },
  mixins: [scrollHeaderMinxin],
  data: function () {
    return {
      player: {
        playerName: '', // 球员名
        height: '', // 身高
        weight: '', // 体重
        salary: '', // 薪金
        graduatedFrom: '', // 毕业院校
        nationality: '', // 国籍
        birthday: '', // 生日
        position: '', // 场上位置
        jerseyNumber: '', // 球衣
        joinDate: '', // 加盟时间
        team: '', // 效力球队
        formerTeam: '',
        playedForTeam: '',
        experience: '', // 阅历
        glory: '', // 个人荣誉
        summary: '' // 个人简介
      }
    }
  },
  computed: {
    routers: function () {
      return [
        [this.$t('playerIndex.playerInfo'), 'basketball-player-info'],
        [this.$t('playerIndex.playerSeasonStats'), 'basketball-player-seasonStats'],
        [this.$t('playerIndex.playerGameLogs'), 'basketball-player-gameLogs'],
        [this.$t('playerIndex.playerCareerStats'), 'basketball-player-careerStats']
      ]
    },
    enName () {
      let regex = /\(([a-zA-Z'\s]*)\)/
      let array = this.player.playerName.match(regex)
      return array ? array[1] : ''
    },
    chineseName () {
      let fullName = this.player.playerName
      return fullName.indexOf('(') > -1 ? this.player.playerName.split('(')[0] : fullName
    }
  },
  components: {
    NavList,
    playerAvatar
  },
  mounted () {
    this.loadData()
  },
  watch: {
    playerId (newValue, oldValue) {
      if (newValue !== oldValue) {
        this.loadData()
      }
    },
    player (newValue) {
      this.$refs.routerView.player = this.player
    }
  },
  methods: {
    loadData () {
      this.$dataBaseClient.get(`b_player/playerInfo?playerId=${this.playerId}`)
        .then((response) => {
          this.player = response
          this.pageTitle = this.chineseName
        })
        .catch((error) => {
          console.log(error)
        })
    }
  }
}
</script>

<style scoped lang="sass">
@import '~@/styles'

.header
  background-size: cover
  background-image: url("~@/assets/player-bGb@2x.png")
  > div
    padding: 20+44px vw(20) vw(20) vw(20)

#avatar
  width: vw(70)
  height: vw(70)
  border: vw(2) solid #ffffff50

.header-line-1
  display: flex
  justify-content: space-between
  margin-bottom: vw(20)

  div
    display: -webkit-box
    flex-direction: column

    div
      text-align: left

      &:nth-child(3)
        margin-bottom: vw(8)

  .sub-title-1
    margin-bottom: vw(12)

.header-line-2
  display: flex
  > div
    margin-right: vw(30)

#player-name
  font-size: vw(24)
  line-height: vw(24)
  color: white
  margin-bottom: vw(7)

%subTitleFont1
  font-size: vw(12)
  line-height: vw(12)

.sub-title-1
  @extend %subTitleFont1
  color: rgba(white, 0.4)

.sub-title-2
  @extend %subTitleFont1
  color: rgba(white, 0.75)

.sub-title-2 :nth-child(1)
  margin-right: vw(20)

.sub-title-3
  font-size: vw(18)
  line-height: vw(18)
  color: rgba(white, 0.75)
  margin-bottom: vw(5)
</style>
